// Schlanker Stream-Manager: haelt die SSE-Verbindung zu /jobs/stream und
// rendert das JobQueuePanel fuer mehrere parallele Jobs.

import React, { useContext, useEffect, useMemo, useRef } from 'react';
import { useSnackbar } from 'notistack';
import { TranscriptionContext } from '../context/TranscriptionContext';
import useJobsStream from './Transcription/useJobsStream';
import JobQueuePanel from './Transcription/JobQueuePanel';

const FINAL_STATUSES = ['completed', 'failed', 'canceled'];

function jobsFingerprint(jobs) {
  return Object.values(jobs || {})
    .map((j) => `${j.jobId}:${j.status}`)
    .sort()
    .join('|');
}

const TranscriptionOverlay = () => {
  const { jobs } = useContext(TranscriptionContext);
  const { enqueueSnackbar } = useSnackbar();
  const lastStatusRef = useRef(new Map());

  useJobsStream({ enabled: true });

  const fingerprint = useMemo(() => jobsFingerprint(jobs), [jobs]);

  useEffect(() => {
    const lastStatuses = lastStatusRef.current;
    for (const job of Object.values(jobs || {})) {
      const prev = lastStatuses.get(job.jobId);
      if (prev && prev !== job.status && FINAL_STATUSES.includes(job.status)) {
        if (job.status === 'failed') {
          const msg =
            job.error?.user_message ||
            job.error?.message ||
            'Eine Transkription ist fehlgeschlagen.';
          enqueueSnackbar(msg, { variant: 'error' });
        } else if (job.status === 'canceled') {
          enqueueSnackbar('Transkription abgebrochen.', { variant: 'info' });
        } else if (job.status === 'completed') {
          enqueueSnackbar(
            `Transkription fertig: ${job.originalFilename || job.jobId?.slice(0, 8)}`,
            { variant: 'success' },
          );
        }
      }
      lastStatuses.set(job.jobId, job.status);
    }
    // aufräumen
    for (const id of Array.from(lastStatuses.keys())) {
      if (!jobs?.[id]) lastStatuses.delete(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fingerprint]);

  return <JobQueuePanel />;
};

export default TranscriptionOverlay;
